/*
 * Judge.me Custom Review Modal
 *
 * Hosts Judge.me's existing review form inside our custom modal so we get
 * full control over styling without rebuilding submission/validation logic.
 *
 * Flow:
 *  1. User clicks our [data-jdgm-modal-open] button
 *  2. We trigger Judge.me's hidden .jdgm-write-rev-link to expand the form
 *  3. We move .jdgm-form-wrapper into #jdgm-modal-form-host
 *  4. On close, we move it back to its original parent
 *
 * Also syncs the .reviews-header__summary numbers from the legacy widget
 * data attributes (data-average-rating, data-number-of-reviews).
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function syncSummary() {
    const widget = document.querySelector('.jdgm-rev-widg');
    if (!widget) return;
    const avg = widget.getAttribute('data-average-rating');
    const count = widget.getAttribute('data-number-of-reviews');
    if (avg) {
      const avgEl = document.querySelector('.js-jdgm-avg');
      if (avgEl) avgEl.textContent = parseFloat(avg).toFixed(2).replace(/\.?0+$/, '') || avg;
    }
    if (count) {
      const countEl = document.querySelector('.js-jdgm-count');
      if (countEl) {
        // Het telwoord komt uit de locale; hardcoded 'review(s)' liet Engels
        // staan op elke anderstalige storefront.
        const word = count === '1'
          ? countEl.dataset.reviewOne || 'review'
          : countEl.dataset.reviewOther || 'reviews';
        countEl.textContent = count + ' ' + word;
      }
    }
  }

  function initModal() {
    const modal = document.getElementById('jdgm-modal');
    if (!modal) return;
    const formHost = document.getElementById('jdgm-modal-form-host');
    const openButtons = document.querySelectorAll('[data-jdgm-modal-open]');
    const closeButtons = modal.querySelectorAll('[data-jdgm-modal-close]');

    let formElement = null;
    let formOriginalParent = null;
    let formOriginalNextSibling = null;

    function findJudgeMeForm() {
      // Judge.me's form wrapper — try several known classes
      return (
        document.querySelector('.jdgm-form-wrapper') ||
        document.querySelector('.jdgm-rev-widg__form') ||
        document.querySelector('.jdgm-form') ||
        document.querySelector('#jdgm-rev-widg-form-modal-wrap') ||
        null
      );
    }

    function bringFormIntoModal() {
      const form = findJudgeMeForm();
      if (!form || form === formElement) return;
      formElement = form;
      formOriginalParent = form.parentNode;
      formOriginalNextSibling = form.nextSibling;
      formHost.innerHTML = ''; // remove loading text
      formHost.appendChild(form);
      // Make sure it's visible inside our modal even if Judge.me set display:none
      form.style.display = 'block';
      form.classList.add('jdgm-form--in-modal');
      // Tag the parent of the submit button so CSS can apply consistent spacing
      // regardless of which Judge.me form variant is loaded.
      tagActionsRow();
    }

    function tagActionsRow() {
      const submit = formHost.querySelector(
        'button[type="submit"], .jdgm-submit-rev, .jdgm-form__submit'
      );
      if (!submit) return;
      const row = submit.parentElement;
      if (row && !row.classList.contains('jdgm-modal-actions-row')) {
        row.classList.add('jdgm-modal-actions-row');
      }
    }

    function returnFormToOrigin() {
      if (!formElement || !formOriginalParent) return;
      if (formOriginalNextSibling && formOriginalNextSibling.parentNode === formOriginalParent) {
        formOriginalParent.insertBefore(formElement, formOriginalNextSibling);
      } else {
        formOriginalParent.appendChild(formElement);
      }
      formElement.classList.remove('jdgm-form--in-modal');
      formElement.style.display = '';
      formElement = null;
      formOriginalParent = null;
      formOriginalNextSibling = null;
    }

    function openModal() {
      // 1. Trigger Judge.me's own "open form" link so they render the form into DOM
      const jdgmLink = document.querySelector('.jdgm-write-rev-link');
      if (jdgmLink) {
        jdgmLink.style.display = 'inline-block';
        jdgmLink.click();
      }
      // 2. Show modal
      modal.removeAttribute('hidden');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      // 3. Wait for Judge.me to inject its form, then move it
      let tries = 0;
      const maxTries = 30;
      const interval = setInterval(function () {
        tries += 1;
        if (findJudgeMeForm()) {
          bringFormIntoModal();
          clearInterval(interval);
        } else if (tries >= maxTries) {
          clearInterval(interval);
          // Fallback message
          formHost.innerHTML =
            '<p class="jdgm-modal__error">Kon het reviewformulier niet laden. Ververs de pagina of probeer het later opnieuw.</p>';
        }
      }, 100);
    }

    function closeModal() {
      returnFormToOrigin();
      modal.setAttribute('hidden', '');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      // Reset host so it shows the loading text next time
      var loadingText = formHost.getAttribute('data-loading-text') || 'Formulier wordt geladen…';
      formHost.innerHTML = '<div class="jdgm-modal__loading">' + loadingText + '</div>';
    }

    openButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openModal();
      });
    });

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        closeModal();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hasAttribute('hidden')) {
        closeModal();
      }
    });
  }

  ready(function () {
    initModal();
    syncSummary();
    // Re-sync after Judge.me's loader has done its work
    setTimeout(syncSummary, 1500);
    setTimeout(syncSummary, 3500);
  });
})();
